let elementToggle = document.getElementsByClassName('iww-image-rights-toggle')[0];
//elementToggle.addEventListener ("click", setBildrechteFooter, false);


//Die Funktion explizit an window binden => globaler scope, sonst funktionert onclick-event nicht
window.setBildrechteFooter = function() {
    let elementWrapper = document.getElementsByClassName('iww-image-rights')[0];
    if (elementWrapper.ariaHidden === 'true') {
        elementWrapper.ariaHidden = 'false';
    } else {
        elementWrapper.ariaHidden = 'true';
    }

    let footerImages = document.querySelectorAll('img');
    let footerImagesontainer = document.getElementsByClassName('iww-footer-picsources-images')[0];
    let footerimagecontainerexists = document.getElementsByClassName('iww-picsource__item')[0];
    // Wenn der Bildrechte Footer noch nicht exisitert, alle Images auf der Seite durchgehen und im Footer das Bild + Source ausgeben (hängt im Imagetitle)
    if (typeof footerimagecontainerexists === 'undefined' || footerimagecontainerexists === undefined){
        footerImages.forEach(item =>
        {
            if (item.hasAttribute("title")){
                let imgTitle = item.getAttribute("title");

                if (imgTitle.indexOf("(Bild:") !== -1){
                    footerImagesontainer = setPicsourceItem(footerImagesontainer, item, imgTitle);
                }
            }
        });
    }
}

/**
 * @param footerImagesontainer
 * @param item
 * @param imgTitle
 * @returns {*}
 */
function setPicsourceItem(footerImagesontainer, item, imgTitle){
    const elem_div = document.createElement("div");
    elem_div.setAttribute("class", "iww-picsource__item");
    const elem_figure = document.createElement("figure");
    elem_figure.setAttribute("class", "iww-picsource__img");
    const elem_picture = document.createElement("picture");
    elem_picture.setAttribute("class", "iww-imgwrapper iww-imgwrapper--169");
    const elem = document.createElement("img");
    elem.setAttribute("src", item.getAttribute("src"));
    elem.setAttribute("height", "180");
    elem.setAttribute("width", "380");
    elem.setAttribute("alt", item.getAttribute("alt"));
    elem.setAttribute("title", imgTitle);
    elem_picture.appendChild(elem);
    elem_figure.appendChild(elem_picture);
    elem_div.appendChild(elem_figure);
    footerImagesontainer.appendChild(elem_div);
    const elem_picsource = document.createElement("p");
    elem_picsource.setAttribute("class", "iww-picsource__text");

    let index_of = imgTitle.indexOf("(Bild:");
    let source = '';
    if (typeof index_of != 'undefined') {
        source = imgTitle.substr(index_of+6);
    }

    elem_picsource.innerText = "© " + source.substr(1,source.length-2);
    footerImagesontainer.appendChild(elem_picsource);

    return footerImagesontainer;
}

// Nach Pagination oder Filtern muss der Bildrechte-Footer neu befüllt werden
function resetBildrechteFooter(){
    // Footer schließen, wenn Footer geoeffnet ist
    let elementWrapper = document.getElementsByClassName('iww-image-rights');
    if(elementWrapper.length > 0)
    {
        elementWrapper = elementWrapper[0];
        if (elementWrapper.ariaHidden === 'true') {
            elementWrapper.ariaHidden = 'false';
        }
    }

    // Bilder entfernen, wenn Footer befuellt ist
    let footerImagesontainer = document.getElementsByClassName('iww-footer-picsources-images');
    if(footerImagesontainer.length > 0)
    {
        footerImagesontainer = footerImagesontainer[0];
        footerImagesontainer.querySelectorAll('.iww-picsource__item').forEach(element => {
            element.remove();
        });
        footerImagesontainer.querySelectorAll('.iww-picsource__text').forEach(element => {
            element.remove();
        });
    }
}


document.addEventListener('DOMContentLoaded', function (event) {
    const imageRights = document.getElementsByClassName('iww-image-rights');
    if(!imageRights || imageRights.length === 0)
    {
        return;
    }

    // Klick auf X schließt Bildquellen
    imageRights[0].addEventListener(
        'click',
        function (e) {
            e.stopPropagation();
        },
        false
    )
    document.getElementsByClassName('iww-image-rights-close')[0].addEventListener(
        'click',
        function (e) {
            let elementWrapper = document.getElementsByClassName('iww-image-rights')[0];
            elementWrapper.ariaHidden = 'false';
        },
        false
    );
    document.addEventListener('htmx:afterSettle', function (e) {
        resetBildrechteFooter();

    })
});
